export enum Products {
  kyiv_date = 'kyiv_date',
  gatekeeper = 'gatekeeper'
}

export enum UserState {
  STATE_UNSPECIFIED = 'STATE_UNSPECIFIED',
  STATE_PENDING = 'STATE_PENDING',
  STATE_ACTIVE = 'STATE_ACTIVE',
  STATE_SHADOWED = 'STATE_SHADOWED',
  STATE_DELETED = 'STATE_DELETED',
  STATE_HIDDEN = 'STATE_HIDDEN',
  STATE_BANNED = 'STATE_BANNED',
  STATE_FROZEN = 'STATE_FROZEN'
}

export enum TonChallengeTypes {
  TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
  TYPE_INVITE_FRIEND = 'TYPE_INVITE_FRIEND',
  TYPE_GET_MATCHES = 'TYPE_GET_MATCHES',
  TYPE_SEVEN_DAY_ACTIVITY_STREAK = 'TYPE_SEVEN_DAY_ACTIVITY_STREAK'
}

export enum TonChallengeStates {
  SOURCE_UNSPECIFIED = 'SOURCE_UNSPECIFIED',
  STATE_LOCKED = 'STATE_LOCKED',
  STATE_IN_PROGRESS = 'STATE_IN_PROGRESS',
  STATE_READY_TO_CLAIM = 'STATE_READY_TO_CLAIM',
  STATE_ARCHIVED = 'STATE_ARCHIVED'
}

export enum TonTransactionTypes {
  TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
  TYPE_INCOME = 'TYPE_INCOME',
  TYPE_WITHDRAWAL = 'TYPE_WITHDRAWAL'
}

export enum TonTransactionStates {
  STATE_PENDING = 'STATE_PENDING',
  STATE_APPROVED = 'STATE_APPROVED',
  STATE_REJECTED = 'STATE_REJECTED'
}

export enum TonTransactionSources {
  SOURCE_UNSPECIFIED = 'SOURCE_UNSPECIFIED',
  SOURCE_CHALLENGE_REWARD = 'SOURCE_CHALLENGE_REWARD',
  SOURCE_ACTIVITY_REWARD = 'SOURCE_ACTIVITY_REWARD'
}

export enum PhotoState {
  STATE_NONE = 'STATE_NONE',
  STATE_CREATED = 'STATE_CREATED',
  STATE_BEING_MODERATED = 'STATE_BEING_MODERATED',
  STATE_APPROVED = 'STATE_APPROVED',
  STATE_REJECTED = 'STATE_REJECTED '
}

export enum VideoState {
  STATE_ACTIVE = 'STATE_ACTIVE',
  STATE_PENDING = 'STATE_PENDING '
}

export enum UserStateReason {
  STATE_REASON_ALL_PHOTOS_REMOVED = 'STATE_REASON_ALL_PHOTOS_REMOVED',
  STATE_REASON_UNSPECIFIED = 'STATE_REASON_UNSPECIFIED',
  STATE_REASON_VERIFICATION_FAILED = 'STATE_REASON_VERIFICATION_FAILED',
  STATE_REASON_BEING_VERIFIED = 'STATE_REASON_BEING_VERIFIED',
  STATE_REASON_VOLUNTARY = 'STATE_REASON_VOLUNTARY'
}

export enum WebSocketEvents {
  TYPE_MESSAGE_INCOMING = 'TYPE_MESSAGE_INCOMING',
  TYPE_DIALOG_CREATED = 'TYPE_DIALOG_CREATED',
  TYPE_DIALOG_DELETED = 'TYPE_DIALOG_DELETED',
  TYPE_DIALOG_DEACTIVATED = 'TYPE_DIALOG_DEACTIVATED',
  TYPE_PHOTO_APPROVED = 'TYPE_PHOTO_APPROVED',
  TYPE_PHOTO_REJECTED = 'TYPE_PHOTO_REJECTED',
  TYPE_USER_ACTIVATED = 'TYPE_USER_ACTIVATED',
  TYPE_USER_VERIFICATION_FAILED = 'TYPE_USER_VERIFICATION_FAILED',
  TYPE_USER_BANNED = 'TYPE_USER_BANNED',
  TYPE_ONE_TIME_PURCHASE = 'TYPE_ONE_TIME_PURCHASE',
  TYPE_LIKE_CREATED = 'TYPE_LIKE_CREATED',
  TYPE_DIALOG_REQUEST_ACCEPTED = 'TYPE_DIALOG_REQUEST_ACCEPTED',
  TYPE_DIALOG_REQUEST_DECLINED = 'TYPE_DIALOG_REQUEST_DECLINED',
  TYPE_SUBSCRIPTION_PURCHASE = 'TYPE_SUBSCRIPTION_PURCHASE',
  TYPE_CONTACT_DELETED = 'TYPE_CONTACT_DELETED',
  TYPE_TON_CHALLENGE_UNLOCKED = 'TYPE_TON_CHALLENGE_UNLOCKED',
  TYPE_TON_CHALLENGE_COMPLETED = 'TYPE_TON_CHALLENGE_COMPLETED',
  TYPE_TON_CHALLENGE_ADVANCED = 'TYPE_TON_CHALLENGE_ADVANCED',
  TYPE_TON_TRANSACTION_CREATED = 'TYPE_TON_TRANSACTION_CREATED',
  TYPE_BLOCK_CREATED = 'TYPE_BLOCK_CREATED',
  TYPE_VIDEO_APPROVED = 'TYPE_VIDEO_APPROVED',
  TYPE_VIDEO_REJECTED = 'TYPE_VIDEO_REJECTED'
}

export enum MessageTypes {
  TYPE_MATCH = 'TYPE_MATCH',
  TYPE_TEXT = 'TYPE_TEXT',
  TYPE_ICEBREAKER_GIFT = 'TYPE_ICEBREAKER_GIFT',
  TYPE_STICKER = 'TYPE_STICKER',
  TYPE_BAIT = 'TYPE_BAIT'
}

export enum MessageLabels {
  LABEL_INBOX = 'LABEL_INBOX',
  LABEL_DELIVERED = 'LABEL_DELIVERED',
  LABEL_SYSTEM = 'LABEL_SYSTEM'
}

export enum DialogLabels {
  LABEL_SYSTEM_CHANNEL = 'LABEL_SYSTEM_CHANNEL',
  LABEL_HAS_INCOMING_MESSAGE = 'LABEL_HAS_INCOMING_MESSAGE',
  LABEL_ACTION_REQUIRED = 'LABEL_ACTION_REQUIRED'
}

export enum PriceLabels {
  LABEL_BEST_PRICE = 'LABEL_BEST_PRICE'
}

export enum TransactionSource {
  SOURCE_PAYMENT = 'SOURCE_PAYMENT',
  SOURCE_SUBSCRIBED = 'SOURCE_SUBSCRIBED'
}

export enum RelationKind {
  KIND_UNSPECIFIED = 'KIND_UNSPECIFIED',
  KIND_FIRST_MOVE = 'KIND_FIRST_MOVE',
  KIND_BLOCK = 'KIND_BLOCK',
  KIND_BLOCKS_ME = 'KIND_BLOCKS_ME',
  KIND_LIKE = 'KIND_LIKE',
  KIND_LIKES_YOU = 'KIND_LIKES_YOU',
  KIND_MATCHED = 'KIND_MATCHED'
}

export enum UserStates {
  ONLINE_STATE_UNSPECIFIED = 'ONLINE_STATE_UNSPECIFIED',
  ONLINE_STATE_ONLINE = 'ONLINE_STATE_ONLINE',
  ONLINE_STATE_RECENTLY_SEEN = 'ONLINE_STATE_RECENTLY_SEEN',
  ONLINE_STATE_OFFLINE = 'ONLINE_STATE_OFFLINE'
}

export enum UserLabels {
  LABEL_JUST_JOINED = 'LABEL_JUST_JOINED',
  LABEL_LIKES_ME = 'LABEL_LIKES_ME'
}

export enum PrivacyLabels {
  CONCEALABLE_ATTRIBUTE_AGE = 'CONCEALABLE_ATTRIBUTE_AGE',
  CONCEALABLE_ATTRIBUTE_LOCATION = 'CONCEALABLE_ATTRIBUTE_LOCATION',
  CONCEALABLE_ATTRIBUTE_ONLINE_STATUS = 'CONCEALABLE_ATTRIBUTE_ONLINE_STATUS'
}

export enum Gender {
  MALE = 'm',
  FEMALE = 'f'
}

export enum PaywallTypes {
  TYPE_ONE_TIME = 'TYPE_ONE_TIME',
  TYPE_SUBSCRIPTION = 'TYPE_SUBSCRIPTION'
}

export enum BodyType {
  BODY_TYPE_UNSPECIFIED = 'BODY_TYPE_UNSPECIFIED',
  BODY_TYPE_THIN = 'BODY_TYPE_THIN',
  BODY_TYPE_AVERAGE = 'BODY_TYPE_AVERAGE',
  BODY_TYPE_ATHLETIC = 'BODY_TYPE_ATHLETIC',
  BODY_TYPE_LARGE = 'BODY_TYPE_LARGE',
  BODY_TYPE_EXTRA_POUNDS = 'BODY_TYPE_EXTRA_POUNDS'
}

export enum EmploymentSector {
  EMPLOYMENT_SECTOR_UNSPECIFIED = 'EMPLOYMENT_SECTOR_UNSPECIFIED',
  EMPLOYMENT_SECTOR_HEALTH_CARE = 'EMPLOYMENT_SECTOR_HEALTH_CARE',
  EMPLOYMENT_SECTOR_MEDIA = 'EMPLOYMENT_SECTOR_MEDIA',
  EMPLOYMENT_SECTOR_IT = 'EMPLOYMENT_SECTOR_IT',
  EMPLOYMENT_SECTOR_TRANSPORTATION_SERVICES = 'EMPLOYMENT_SECTOR_TRANSPORTATION_SERVICES',
  EMPLOYMENT_SECTOR_MANUFACTURE = 'EMPLOYMENT_SECTOR_MANUFACTURE',
  EMPLOYMENT_SECTOR_MANAGEMENT = 'EMPLOYMENT_SECTOR_MANAGEMENT',
  EMPLOYMENT_SECTOR_DEFENSE = 'EMPLOYMENT_SECTOR_DEFENSE',
  EMPLOYMENT_SECTOR_CONSTRUCTION = 'EMPLOYMENT_SECTOR_CONSTRUCTION',
  EMPLOYMENT_SECTOR_SERVICE = 'EMPLOYMENT_SECTOR_SERVICE',
  EMPLOYMENT_SECTOR_FINANCE = 'EMPLOYMENT_SECTOR_FINANCE',
  EMPLOYMENT_SECTOR_EDUCATION = 'EMPLOYMENT_SECTOR_EDUCATION',
  EMPLOYMENT_SECTOR_AGRICULTURE = 'EMPLOYMENT_SECTOR_AGRICULTURE',
  EMPLOYMENT_SECTOR_ARCHITECTURE = 'EMPLOYMENT_SECTOR_ARCHITECTURE',
  EMPLOYMENT_SECTOR_ARTS_AND_DESIGN = 'EMPLOYMENT_SECTOR_ARTS_AND_DESIGN',
  EMPLOYMENT_SECTOR_ENERGY_INDUSTRY = 'EMPLOYMENT_SECTOR_ENERGY_INDUSTRY',
  EMPLOYMENT_SECTOR_ENGINEERING = 'EMPLOYMENT_SECTOR_ENGINEERING',
  EMPLOYMENT_SECTOR_GOVERNMENT = 'EMPLOYMENT_SECTOR_GOVERNMENT',
  EMPLOYMENT_SECTOR_HOSPITALITY = 'EMPLOYMENT_SECTOR_HOSPITALITY',
  EMPLOYMENT_SECTOR_SECURITY_INDUSTRY = 'EMPLOYMENT_SECTOR_SECURITY_INDUSTRY',
  EMPLOYMENT_SECTOR_SOCIAL_SERVICES = 'EMPLOYMENT_SECTOR_SOCIAL_SERVICES',
  EMPLOYMENT_SECTOR_SPORTS = 'EMPLOYMENT_SECTOR_SPORTS',
  EMPLOYMENT_SECTOR_TOURISM = 'EMPLOYMENT_SECTOR_TOURISM',
  EMPLOYMENT_SECTOR_OTHER = 'EMPLOYMENT_SECTOR_OTHER'
}

export enum SpokenLanguages {
  LANGUAGE_ENGLISH = 'LANGUAGE_ENGLISH',
  LANGUAGE_SPANISH = 'LANGUAGE_SPANISH',
  LANGUAGE_ITALIAN = 'LANGUAGE_ITALIAN',
  LANGUAGE_GERMAN = 'LANGUAGE_GERMAN',
  LANGUAGE_FRENCH = 'LANGUAGE_FRENCH',
  LANGUAGE_AZERBAIJANI = 'LANGUAGE_AZERBAIJANI',
  LANGUAGE_ARMENIAN = 'LANGUAGE_ARMENIAN',
  LANGUAGE_BELORUSSIAN = 'LANGUAGE_BELORUSSIAN',
  LANGUAGE_GEORGIAN = 'LANGUAGE_GEORGIAN',
  LANGUAGE_HEBREW = 'LANGUAGE_HEBREW',
  LANGUAGE_KAZAKH = 'LANGUAGE_KAZAKH',
  LANGUAGE_KYRGYZ = 'LANGUAGE_KYRGYZ',
  LANGUAGE_LATVIAN = 'LANGUAGE_LATVIAN',
  LANGUAGE_LITHUANIAN = 'LANGUAGE_LITHUANIAN',
  LANGUAGE_MOLDAVIAN = 'LANGUAGE_MOLDAVIAN',
  LANGUAGE_TAJIK = 'LANGUAGE_TAJIK',
  LANGUAGE_TURKMEN = 'LANGUAGE_TURKMEN',
  LANGUAGE_UZBEK = 'LANGUAGE_UZBEK',
  LANGUAGE_UKRAINIAN = 'LANGUAGE_UKRAINIAN',
  LANGUAGE_ESTONIAN = 'LANGUAGE_ESTONIAN',
  LANGUAGE_GREEK = 'LANGUAGE_GREEK',
  LANGUAGE_RUSSIAN = 'LANGUAGE_RUSSIAN',
  LANGUAGE_PORTUGUESE = 'LANGUAGE_PORTUGUESE',
  LANGUAGE_POLISH = 'LANGUAGE_POLISH'
}

export enum SmokingStatus {
  SMOKING_STATUS_UNSPECIFIED = 'SMOKING_STATUS_UNSPECIFIED',
  SMOKING_STATUS_OCCASIONALLY = 'SMOKING_STATUS_OCCASIONALLY',
  SMOKING_STATUS_YES = 'SMOKING_STATUS_YES',
  SMOKING_STATUS_NONSMOKER = 'SMOKING_STATUS_NONSMOKER'
}

export enum AlcoholPreference {
  ALCOHOL_PREFERENCE_UNSPECIFIED = 'ALCOHOL_PREFERENCE_UNSPECIFIED',
  ALCOHOL_PREFERENCE_OFTEN_ENOUGH = 'ALCOHOL_PREFERENCE_OFTEN_ENOUGH',
  ALCOHOL_PREFERENCE_SOCIALLY = 'ALCOHOL_PREFERENCE_SOCIALLY',
  ALCOHOL_PREFERENCE_DONT_DRINK_ALCOHOL = 'ALCOHOL_PREFERENCE_DONT_DRINK_ALCOHOL'
}

export enum ZodiacSign {
  ZODIAC_SIGN_UNSPECIFIED = 'ZODIAC_SIGN_UNSPECIFIED',
  ZODIAC_SIGN_ARIES = 'ZODIAC_SIGN_ARIES',
  ZODIAC_SIGN_TAURUS = 'ZODIAC_SIGN_TAURUS',
  ZODIAC_SIGN_GEMINI = 'ZODIAC_SIGN_GEMINI',
  ZODIAC_SIGN_CANCER = 'ZODIAC_SIGN_CANCER',
  ZODIAC_SIGN_LEO = 'ZODIAC_SIGN_LEO',
  ZODIAC_SIGN_VIRGO = 'ZODIAC_SIGN_VIRGO',
  ZODIAC_SIGN_LIBRA = 'ZODIAC_SIGN_LIBRA',
  ZODIAC_SIGN_SCORPIO = 'ZODIAC_SIGN_SCORPIO',
  ZODIAC_SIGN_SAGITTARIUS = 'ZODIAC_SIGN_SAGITTARIUS',
  ZODIAC_SIGN_CAPRICORN = 'ZODIAC_SIGN_CAPRICORN',
  ZODIAC_SIGN_AQUARIUS = 'ZODIAC_SIGN_AQUARIUS',
  ZODIAC_SIGN_PISCES = 'ZODIAC_SIGN_PISCES'
}

export enum ReportReason {
  INAPPROPRIATE_BEHAVIOR = 'inappropriate_behavior',
  FAKE_PROFILE = 'fake_profile',
  SPAM = 'spam',
  HARASSMENT = 'harassment',
  OFFENSIVE_CONTENT = 'offensive_content'
}

export enum ProductInvoicePlacements {
  PROFILE_PAGE_GET_PREMIUM = 'profile_page_get_premium',
  PROFILE_PAGE_GET_REACTIONS = 'profile_page_get_reactions',
  MATCHMAKER_BOOST_LIKES_UPSALE_CARD = 'matchmaker_boost_likes_upsale_card',
  MATCHMAKER_SEND_REACTION_BUTTON = 'matchmaker_send_reaction_button',
  MATCHMAKER_LIKES_LIMIT_POPUP = 'matchmaker_likes_limit_popup',
  MATCHMAKER_PROFILE_HIDDEN_LOCK_SCREEN = 'matchmaker_profile_hidden_lock_screen',
  DIALOGS_HEADER_GET_REACTIONS = 'dialogs_header_get_reactions',
  LIKED_YOU_HIDDEN_LIKES_GET_PREMIUM = 'liked_you_hidden_likes_get_premium',
  YOUR_LIKES_PAGE_BOOST_LIKES_CARD = 'your_likes_page_boost_likes_card',
  YOUR_LIKES_SEND_REACTION_BUTTON = 'your_likes_send_reaction_button',
  PROFILE_SETTINGS_SWITCHERS = 'profile_settings_switchers',
  MATCHMAKER_PREMIUM_UPSALE_POPUP = 'matchmaker_premium_upsale_popup',
  BAIT_DIALOG = 'chat_bait_dialog',
  MATCHMAKER_REACTIONS_AND_PREMIUM_UPSALE_POPUP = 'matchmaker_reactions_and_premium_upsale_popup',
  sent_likes_list_banner_paywall = 'sent_likes_list_banner_paywall'
}

export const Policies = {
  onboarding: `${UserState.STATE_PENDING}/${UserStateReason.STATE_REASON_UNSPECIFIED}`,
  beingVerified: `${UserState.STATE_PENDING}/${UserStateReason.STATE_REASON_BEING_VERIFIED}`,
  failedVerification: `${UserState.STATE_PENDING}/${UserStateReason.STATE_REASON_VERIFICATION_FAILED}`,
  insufficientData: `${UserState.STATE_SHADOWED}/${UserStateReason.STATE_REASON_ALL_PHOTOS_REMOVED}`,
  deleted: `${UserState.STATE_DELETED}/${UserStateReason.STATE_REASON_UNSPECIFIED}`,
  incognitoMode: `${UserState.STATE_SHADOWED}/${UserStateReason.STATE_REASON_VOLUNTARY}`,
  banned: UserState.STATE_BANNED,
  hidden: UserState.STATE_HIDDEN,
  active: UserState.STATE_ACTIVE
} as const;

export type PoliciesKey = keyof typeof Policies;
